<template>
  <div v-loading="pageLoading">
    <div>
      <h1>課程內容</h1>
      <el-form label-width="110px">
        <el-form-item label="接受用戶列表">
          <!-- 按组别指定style="width:100%;" v-if="tableData[0].code"-->
          <template class="group"
                    v-if="chooseValue == '0'">
            <el-table :data="tableData"
                      empty-text="暫無記錄"
                      border
                      style="width: 70%"
                      max-height="300">
              <el-table-column prop="regionName"
                               label="分公司"></el-table-column>
              <el-table-column prop="branchName"
                               label="部門/物業"></el-table-column>
              <!-- <el-table-column prop="departmentName"
                               label="用戶組別"></el-table-column> -->
              <el-table-column prop="positionName"
                               label="職位"></el-table-column>
              <!-- <el-table-column label="操作"
                               width="100px">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="danger"
                             @click="del(scope.$index)">刪除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </template>
          <!-- 用户组别 -->
          <template class="group"
                    v-if="chooseValue == '3'">
            <el-table :data="tableData"
                      empty-text="暫無記錄"
                      border
                      style="width: 70%"
                      max-height="300">
              <el-table-column prop="regionName"
                               label="分公司"></el-table-column>
              <el-table-column prop="branchName"
                               label="部門/物業"></el-table-column>
              <el-table-column prop="departmentName"
                               label="用戶組別"></el-table-column>
              <!-- <el-table-column prop="positionName"
                               label="组别"></el-table-column> -->
              <!-- <el-table-column label="操作"
                               width="100px">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="danger"
                             @click="del(scope.$index)">刪除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </template>
          <!-- 按職員編號指定 v-if="workTable[0].workNo"-->
          <template v-if="chooseValue == '1'">
            <el-table :data="tableData"
                      empty-text="暫無記錄"
                      border
                      style="width: 70%"
                      max-height="300">
              <el-table-column prop="workNo"
                               label="员工编号"></el-table-column>
              <el-table-column prop="name"
                               label="姓名"></el-table-column>
              <el-table-column prop="address"
                               label="英文名"></el-table-column>
              <el-table-column prop="manRegionName"
                               label="分公司"></el-table-column>
              <el-table-column prop="manBranchName"
                               label="部門/物業"></el-table-column>
              <el-table-column prop="manDepartmentName"
                               label="用戶組別"></el-table-column>
              <el-table-column prop="manPositionName"
                               label="组别"></el-table-column>
              <!-- <el-table-column label="操作"
                               width="100px">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="danger"
                             @click="delWorkNum(scope.$index)">刪除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
            <div style="margin: 20px 0"></div>
          </template>
        </el-form-item>
        <el-form-item label="課程時間"
                      v-if="courseType == 'online'">{{
          startCourseTime + " 至 " + endCourseTime
        }}</el-form-item>
        <el-form-item label="報名時間"
                      v-if="courseType == 'offline'">{{
          startSignUpTime + " 至 " + endSignUpTime
        }}</el-form-item>
        <el-form-item label="課程時間"
                      v-if="courseType == 'offline'">{{
          startCourseTime + " 至 " + endCourseTime
        }}</el-form-item>
        <el-form-item label="是否必修課"
                      v-if="courseType == 'online'"
                      prop="obligatory">{{ obligatory }}</el-form-item>
        <el-form-item label="是否ESG課程"
                      prop="esgType">{{ esgType }}</el-form-item>
        <el-form-item label="限制人數"
                      v-if="courseType == 'offline'">{{
          limit
        }}</el-form-item>
        <el-form-item label="課程編號">{{ coursesNo }}</el-form-item>
        <el-form-item label="課程名稱">{{ courseName }}</el-form-item>
        <el-form-item label="課程簡介">
          <div class="text-box">{{ intro }}</div>
        </el-form-item>
        <el-form-item v-if="courseType!='live'" label="列表封面"><img class="cover"
               :src="listCoverUrl"
               alt="列表封面" /></el-form-item>
        <el-form-item label="課程封面"><img class="cover"
               :src="coverUrl"
               alt="課程封面" /></el-form-item>
        <el-form-item class="code"
                      v-if="courseType == 'offline'"
                      label="課程二維碼"><img :src="qrCodeFile" /></el-form-item>
        <el-form-item label="章節列表"
                      v-if="courseList.length != 0">
          <!-- v-if="courseList.length !=0" -->
          <ol>
            <li v-for="(item, index) in courseList"
                :key="item.id">
              <h4>{{ item.sectionName }}</h4>
              <div>
                <div class="text-box"
                     style="margin-bottom: 12px">
                  {{ item.intro }}
                </div>
                <div v-if="courseType == 'live'">
                  章節直播時間：{{item.liveTime}}
                </div>
                <div style="display: inline"
                     v-show="courseType == 'live'">
                  <el-button v-if="item.isLive == 0"
                             type="primary"
                             @click="live(item.id)">開始直播</el-button>
                  <el-button v-if="item.isLive == 1"
                             type="primary"
                             @click="accessLive(item.id)">進入直播</el-button>
                  <el-button v-if="item.isLive == 2"
                             type="primary"
                             @click="viewLive(item.id, index)">查看回放</el-button>
                </div>
                <div class="section-btn">
                  <el-button v-if="item.pictureFile || item.videoFile || item.contentFile"
                    @click="showFile(item)">查看章节教材</el-button>
                  <!-- v-if="item.tuList.length  != 0" -->
                  <el-button type="primary"
                            v-if="item.tuList.length != 0"
                            @click="viewTest(index)">查看試卷</el-button>
                  <el-button type="primary"
                            v-if="item.ueviomsId.length != 0"
                            @click="viewAssessment(item.id)">查看反饋</el-button>
                  <el-button type="primary"
                            @click="learning(item)">學習記錄分析</el-button>
                </div>
              </div>
            </li>
          </ol>
        </el-form-item>
      </el-form>
      <el-button class="btn"
                 @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pageLoading: false,

      courseName: "",
      intro: "",
      enrollmentTime: "",
      coursesNo: "",
      courseType: "",
      tableData: [],
      chooseValue: "",
      courseList: [],
      courseId: "",
      coverUrl: "",
      listCoverUrl: "",
      qrCodeFile: "",
      startSignUpTime: "",
      endSignUpTime: "",
      startCourseTime: "",
      obligatory: "",
      esgType:"",
      endCourseTime: "",
      limit: "",
      appoint: '',
    };
  },
  mounted () {
    $("#pageHead").text("課程詳情");
  },
  created () {
    this.courseId = sessionStorage.getItem("courseId");
    var type = sessionStorage.getItem("courseType");
    this.courseType = type;
    if (type == "online") {
      //線上
      this.pageLoading = true
      this.axios({
        url: "/manage/getManOnlineCourses",
        params: {
          id: this.courseId,
        },
      }).then((res) => {
        if (res) {
          var msg = res.result[0];
          this.courseName = msg.courseName;
          this.intro = msg.intro;
          this.tableData = msg.coursesUsers;
          this.courseList = msg.courseSection;
          this.coursesNo = msg.coursesNo;
          this.startCourseTime = msg.startCourseTime;
          this.endCourseTime = msg.endCourseTime;
          this.enrollmentTime = msg.enrollmentTime;
          this.coverUrl = msg.cover;
          this.listCoverUrl = msg.listCover;
          this.appoint = msg.appoint
          if (msg.obligatory == "1") {
            this.obligatory = "必修";
          }
          if (msg.obligatory == "0") {
            this.obligatory = "選修";
          }
          if(msg.esgType == "1"){
              this.esgType = "否";
          }else{
              this.esgType = "是";
          }
        }
        if (this.appoint == '0') {
          this.chooseValue = "0"; // 组别
        }
        if (this.appoint == '1') {
          this.chooseValue = "1"; // 工号
        }
        if (this.appoint == '3') {
          this.chooseValue = "3"; //用户组别
        }
        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    } else if (type == "offline") {
      this.pageLoading = true
      this.axios
        .get("/manage/getManOfflineCourses?id=" + this.courseId)
        .then((res) => {
          var msg = res.result[0];
          this.courseName = msg.courseName;
          this.intro = msg.intro;
          this.tableData = msg.coursesUsers;
          this.courseList = msg.courseSection;
          this.coursesNo = msg.coursesNo;
          this.enrollmentTime = msg.enrollmentTime;
          this.coverUrl = msg.cover;
          this.listCoverUrl = msg.listCover;
          this.qrCodeFile = msg.qrCodeFile;
          this.startSignUpTime = msg.startSignUpTime;
          this.endSignUpTime = msg.endSignUpTime;
          this.startCourseTime = msg.startCourseTime;
          this.endCourseTime = msg.endCourseTime;
          this.limit = msg.limit;
          this.appoint = msg.appoint
          if (this.appoint == '0') {
            this.chooseValue = "0"; // 组别
          }
          if (this.appoint == '1') {
            this.chooseValue = "1"; // 工号
          }
          if (this.appoint == '3') {
            this.chooseValue = "3"; //用户组别
          }
          // 必修選修
          if (msg.obligatory == "1") {
            this.obligatory = "必修";
          }
          if (msg.obligatory == "0") {
            this.obligatory = "選修";
          }

          if(msg.esgType == "1"){
              this.esgType = "否";
          }else{
              this.esgType = "是";
          }
          
          this.pageLoading = false
        }).catch(() => {
          this.pageLoading = false
        })
    } else if (type == "live") {
      this.pageLoading = true
      this.axios({
        url: "/manage/getManLiveCourses",
        params: {
          id: this.courseId,
        },
      }).then((res) => {
        if (res) {
          // console.log("详情数据",res)
          var msg = res.result[0];
          this.courseName = msg.courseName;
          this.intro = msg.intro;
          this.tableData = msg.coursesUsers;
          this.courseList = msg.courseSection;
          this.coursesNo = msg.coursesNo;
          this.appoint = msg.appoint
          this.enrollmentTime = msg.enrollmentTime;
          this.coverUrl = msg.cover;
        }
        if (this.appoint == '0') {
          this.chooseValue = "0"; // 组别
        }
        if (this.appoint == '1') {
          this.chooseValue = "1"; // 工号
        }
        if (this.appoint == '3') {
          this.chooseValue = "3"; //用户组别
        }

        // 必修選修
        if (msg.obligatory == "1") {
          this.obligatory = "必修";
        }
        if (msg.obligatory == "0") {
          this.obligatory = "選修";
        }

        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    }
  },
  methods: {
    learning (item) {
      sessionStorage.sectionMsg = JSON.stringify(item);
      this.$router.push("/home/learningDetails");
      // this.$router.push("/home/learningDetails",{
      //     name: 'Describe',
      //     params: {
      //       id: id
      //     }
      //   })
    },
    viewTest (index) {
      var tuList = this.courseList[index].tuList[0]
      sessionStorage.testingId = tuList.testingId;
      // sessionStorage.sectionMsg = JSON.stringify(tuList);
      // sessionStorage.sectionId = id;
      this.$router.push("/home/testPaper");
    },
    viewAssessment (id) {
      sessionStorage.sectionId = id;
      this.$router.push("/home/assessment");
    },
    viewLive (id) {
      sessionStorage.liveId = id;
      this.$router.push("/home/viewLive");
    },
    live (id) {
      sessionStorage.liveId = id;
      this.$router.push("/home/live");
    },
    accessLive (id) {
      sessionStorage.liveId = id;
      this.$router.push("/home/accessLive");
    },
    showFile (item) {
      let link = document.createElement("a");
      link.setAttribute(
        "href", item.pictureFile || item.videoFile || item.contentFile
      );
      link.setAttribute(
        "target", "_blank"
      )
      link.click();
      link.remove();
    }
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}

ol button {
  margin-left: 20px;
}

ol h4 {
  margin: 10px 0;
}

.code img {
  width: 100px;
}

.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}

.cover {
  max-width: 18.75rem;
}

.text-box {
  width: 70%;
  line-height: 1.5;
  padding-top: 10px;
}

.section-btn {
  display: flex;
}
</style>
